import env from '@src/environment';

export const {
    getDay,
    getDayNo,
    shortDate,
    shortOptions,
    shortOptionsWithTime,
} = {
    getDay: (n: number): string => {
        const days = [
            'Minggu',
            'Senin',
            'Selasa',
            'Rabu',
            'Kamis',
            'Jumat',
            'Sabtu',
        ];
        return days[n];
    },
    getDayNo: (day: string): number => {
        const days = [
            'minggu',
            'senin',
            'selasa',
            'rabu',
            'kamis',
            'jumat',
            'sabtu',
        ];
        return days.indexOf(day.toLowerCase());
    },
    /**
     * Get long date format
     * @param date
     * @returns The data will be formatted as "Sen, 1 Jan 2021"
     */
    shortDate: (date: string): string => {
        const d = new Date(date);
        return d.toLocaleDateString(env.localFormat, shortOptions);
    },
    shortOptions: {
        weekday: 'short',
        year: 'numeric',
        month: 'short',
        day: 'numeric',
    } as Intl.DateTimeFormatOptions,
    shortOptionsWithTime: {
        weekday: 'short',
        year: 'numeric',
        month: 'short',
        day: 'numeric',
        hour: 'numeric',
        minute: 'numeric',
    } as Intl.DateTimeFormatOptions,
};
